(($, window, document, undefined) => {
    let Progress = function (elem, options) {
        this.elem = elem;
        this.$elem = $(elem);
        this.options = options;
        this.metaData = this.$elem.data('progress-options');
        this._dialogInstant;
        this._init();
    };

    Progress.prototype = {
        defaults: {
            delay: 500,
            message: 'Need a message.',
            compact: false,
            useMetaData: true
        },
        modal: {
            Transparent: (function () { return $('<div/>').attr({ 'class': 'modal-backdrop fade', 'data-dyn-el': 'true', 'data-transparent-el': 'true' }); }()),
            OverLay: (function () { return $('<div/>').attr({ 'class': 'modal-backdrop fade in', 'data-dyn-el': 'true' }); }()),
            Wrapper: (function () { return $('<div/>').attr({ 'id': 'modalProgress', 'class': 'modal modal-vmiddle fade in', 'tabindex': '-1', 'role': 'dialog', 'aria-labelledby': 'modalProgress', 'data-backdrop': 'static', 'data-dyn-el': 'true', 'aria-hidden': 'false', 'style': 'display:none' }); }()),
            Dialog: (function () { return $('<div/>').attr({ 'class': 'modal-dialog modal-md', 'data-dyn-el': 'true' }); }()),
            Content: (function () { return $('<div/>').attr({ 'class': 'modal-content', 'data-dyn-el': 'true' }); }()),
            Body: (function () { return $('<div/>').attr({ 'class': 'modal-body', 'data-dyn-el': 'true' }); }()),
            Message: (function () { return $('<h4/>').attr({ 'class': 'text-center loading-spinner', 'data-dyn-el': 'true', 'data-dyn-content': 'true' }); }()),
        },
        open: function () { return this._onOpen(); },
        close: function (v) { return this._onClose(); },
        autoClose: function () { return this._onAutoClose(); },
        _status: {
            get: function () {
                if (GSS.common.isNotNullOrEmpty($('body').data('status'))) { return $('body').data('status'); }
                return 0;
            },
            set: function (val) { $('body').data('status', val); },
            open: 1,
            close: 0,
            cancelled: 2,
        },
        _init: function () {
            this.override = $.extend({}, this.defaults, this.options);
            if (this.override.useMetaData) { this.config = $.extend({}, this.defaults, this.options, this.metaData); }
            else { this.config = $.extend({}, this.defaults, this.options); }
            return this;
        },
        _onOpen: function () {
            if (Progress.prototype._status.get() === Progress.prototype._status.cancelled) {
                this.$elem.append(this.modal.Transparent);
                Progress.prototype._status.set(Progress.prototype._status.close)
            }

            // If a spinner already loaded, no need to spin a new one!
            if (Progress.prototype._status.get() !== Progress.prototype._status.open) {
                GSS.common.wait(this.config.delay).done(x => {
                    // only create progress loading and display if it is not yet showing
                    if (Progress.prototype._status.get() === Progress.prototype._status.close) {
                        Progress.prototype._status.set(Progress.prototype._status.open)
                        this._onCreate();
                    }
                });
            }
        },
        _onCreate: function () {
            if (this.config.compact) {
                this.modal.Message.css("paddingLeft", "10px");
                this.modal.Dialog.width(100);
            }
            else {
                this.modal.Message.html(this.config.message);
            }
            $('[data-transparent-el]').each(function () { this.parentNode.removeChild(this); })
            this.modal.Body.append(this.modal.Message);
            this.modal.Content.append(this.modal.Body);
            this.modal.Dialog.append(this.modal.Content);
            this._dialogInstant = this.modal.Wrapper.append(this.modal.Dialog);

            let _overLay = this.$elem.find('.modal-backdrop').length;
            if (_overLay === 0) { this.$elem.append(this.modal.OverLay); }
            this.$elem.append(this._dialogInstant);
            this.modal.Wrapper.show();

            // add text for the screen reader.
            if ($('#ariaLiveSection').length > 0) { $('#ariaLiveSection').empty().html(this.config.message); }
        },
        _onClose: function () {
            Progress.prototype._closed();
            if (Progress.prototype._status.get() !== Progress.prototype._status.open) {
                // not yet opened, so set it to cancelled.
                Progress.prototype._status.set(Progress.prototype._status.cancelled);
            }
            else {
                Progress.prototype._destroy();
            }
            // clear the screen reader text.
            if ($('#ariaLiveSection').length > 0) { $('#ariaLiveSection').empty(); }
        },
        _closed: function () {
            $('[data-dyn-el]').each(function () { this.parentNode.removeChild(this); });
        },
        _destroy: function () {
            $('[data-dyn-el]').each(function () { this.parentNode.removeChild(this); });
            $('body').data('status', '');
        },
        _onAutoClose: function () {
            // this is needed when the plug in is used as extend jquery
            $(document).ajaxStop(() => {
                return Progress.prototype._onClose();
            });
            $(document).ajaxError(() => {
                return Progress.prototype._destroy();
            });
        },
    }

    $.fn.gssAjaxProgress = function (options) {
        return this.each(function () {
            let _p = new Progress(this, options);
            _p.open();
            _p.autoClose();
        });
    };

    (<any>window).Progress = Progress;

    /// <summary>This plug in will automatic disable DOM for a short period of time. Default duration time now is 2 milli second </summary>;
    /// <param name="options.duration">How long a DOM will be disable. Default is 2000, about 2 second.</param>
    /// <param name="options.inputTypes">A list of DOM type that will be affected.</param>
    /// <param name="options.disableText">Text that will be replaced while the DOM is disable.</param>
    /// <param name="options.allowChangeText">Allow the DOM's text change whild it is disable or not.</param>
    $.fn.gssAutoDisable = function (options?: any): JQuery {
        let _defaults: Object = {
            duration: 2000,
            inputTypes: ["button"],
            disableText: "Processing...",
            allowChangeText: false,
        };
        let _options: any = $.extend({}, _defaults, options);
        let _$self: JQuery = $(this);
        let _tagName: string = _$self.prop('tagName');
        if (GSS.common.isNotNullOrEmpty(_tagName)) {
            _tagName = _tagName.toLowerCase();
        }
        let _allowType: boolean = (function () {
            for (let i = 0; i <= _options.inputTypes.length; ++i) {
                if (_options.inputTypes[i] == _tagName) { return true; }
            }
            return false;
        }());

        let _changeContent = (): void => {
            if (_options.allowChangeText) {
                // Get DOM text
                let _oldText = _$self.val() || _$self.text();

                // Change DOM text
                _$self.text(_options.disableText);

                GSS.common.wait(_options.duration).then(function () {
                    // Restore DOM text
                    _$self.text(_oldText);
                })
            }
        };

        if ((_allowType) && (_options.duration > 0)) {
            _changeContent();
            if (_$self.is('a')) {
                _$self.attr("disabled", "disabled");
                GSS.common.wait(_options.duration).then(function () { _$self.removeAttr("disabled"); })
            }
            else if (_$self.is('form')) {
                _$self.find('input[type=submit]').prop("disabled", true);
                GSS.common.wait(_options.duration).then(function () { _$self.find('input[type=submit]').prop("disabled", false); })
            }
            else {
                _$self.prop("disabled", true);
                GSS.common.wait(_options.duration).then(function () { _$self.prop("disabled", false); })
            }
        }

        return _$self;
    };

    /// <summary>Return an array of elements by data attribute and with or without value</summary>
    $.fn.gssGetElementByData = function (prop: string, val: string): JQuery {
        let _$self = this;
        GSS.common.preCondition(prop, "data attribute property");
        if (prop.indexOf('data') !== -1) { prop = prop.replace('data-', ''); }
        if (typeof val === 'undefined') { return _$self.filter(function () { return typeof $(this).data(prop) !== 'undefined'; }); }
        return _$self.filter(function () { return $(this).data(prop) == val; });
    };

    /// <summary>Get data attribute value by property</summary>
    $.fn.gssData = function (prop: string): JQuery {
        let _$self = this;
        GSS.common.preCondition(prop, "data attribute property");
        if (prop.indexOf('data') !== -1) { prop = prop.replace('data-', ''); }
        return $(this).data(prop);
    };

    /// <summary>Check if element exists by data attribute property and its value</summary>
    $.fn.gssHasElementByData = function (prop: string, val: string): boolean {
        let _$self = this;
        if (prop.indexOf('data') !== -1) { prop = prop.replace('data-', ''); }
        if (typeof prop === 'undefined') { throw new Error("Need to specify data attribute property."); }
        if (typeof val === 'undefined') { throw new Error("Need to specify data attribute value."); }
        let _elements = _$self.filter(function () { return $(this).data(prop) == val; });
        return _elements.length > 0;
    };

    $.fn.gssElementExists = function () {
        return this.length > 0;
    };

    $.fn.gssRemoveClass = function (cssClass: string) {
        let _$self = this;
        if (_$self.hasClass(cssClass)) {
            _$self.removeClass(cssClass);
        }
        return _$self;
    };

    $.fn.gssAddClass = function (cssClass: string) {
        let _$self = this;
        if (!_$self.hasClass(cssClass)) {
            _$self.addClass(cssClass);
        }
        return _$self;
    };

    $.fn.gssMoveToSection = function (delay?: number) {
        let _delay = delay || 10;
        $('html, body').animate({
            scrollTop: $(this).offset().top
        }, _delay);
    };
    // need to provide the textbox element that is next to the search button
    // in order to have this works.
    $.fn.gssSearchByEnterKey = function () {
        let _$self = $(this);
        _$self.on('keydown', function (event) {
            if (event.keyCode == 13) { // enter was pressed
                event.stopPropagation();
                event.preventDefault();
                _$self.next().find(':button').trigger('click');
            }
        });
        return _$self;
    };

    // can be used with/without callbackk function
    // if there is no callback function, it will default to click event of the element itself
    // How to pass callback function: $('#buttonId').gssEnterKey(true, ()=>{your awesome code here});
    $.fn.gssEnterKeyDown = function (stop?: boolean, cb?: Function) {
        let _$self = $(this);
        _$self.on('focus', function () {
            $(this).on('keypress keydown', (e) => {
                if (e.keyCode == 13) {
                    if (stop) {
                        event.stopPropagation();
                        event.preventDefault();
                    }
                    if ($.isFunction(cb)) { cb.call(this); }
                    else { $(this).trigger('click'); }
                }
            });
        });
        _$self.on('blur focusout', function () {
            $(this).off('keypress keydown');
        });
    };
})(jQuery, window, document, undefined);

(($, window, document, undefined) => {
    let Confirm = function (elem, options) {
        this.elem = elem;
        this.options = options;
        $('body').removeData('ok');
        $('body').removeData('cancel');
    };

    Confirm.prototype = {
        defaults: {
            title: 'Delete',
            message: 'You are about to delete the thing. Are you sure?',
            cancelLabel: 'Cancel',
            isConfirmWindow: true,
            okLabel: 'Delete',
            okFunction: function () { },
            cancelFunction: function () { },
        },
        init: function () {
            this.config = $.extend({}, this.defaults, this.options);
            $('body').data('ok', this.config.okFunction);
            $('body').data('cancel', this.config.cancelFunction);
            this.onCreate();
            return this;
        },
        modal: {
            OverLay: (function () { return $('<div/>').attr({ 'class': 'modal-backdrop fade in', 'data-dyn-confirm': 'true' }); }()),
            Wrapper: (function () { return $('<div/>').attr({ 'id': 'confirmDialog', 'class': 'modal modal-vmiddle fade in', 'tabindex': '-1', 'role': 'dialog', 'aria-labelledby': 'confirmDialog', 'data-backdrop': 'static', 'data-dyn-confirm': 'true', 'aria-hidden': 'false', 'style':'display:none' }); }()),
            Dialog: (function () { return $('<div/>').attr({ 'class': 'modal-dialog modal-sm modal-simple', 'data-dyn-confirm': 'true' }); }()),
        },
        modalContent: {
            Content: (function () { return $('<div/>').attr({ 'class': 'modal-content', 'data-dyn-confirm': 'true' }); }()),
            Header: (function () { return $('<div/>').attr({ 'class': 'modal-header', 'data-dyn-confirm': 'true' }); }()),
            HeaderTitle: (function () { return $('<h4/>').attr({ 'data-dyn-confirm': 'true' }); }()),
            Body: (function () { return $('<div/>').attr({ 'class': 'modal-body', 'data-dyn-confirm': 'true' }); }()),
            Footer: (function () { return $('<div/>').attr({ 'class': 'modal-footer', 'data-dyn-confirm': 'true' }); }()),
        },
        action: {
            Cancel: (function () { return $('<button/>').attr({ 'class': 'btn btn-link', 'data-dismiss': 'modal', 'data-dyn-confirm': 'true', 'id': GSS.common.getUniqueId() }) }()),
            OK: (function () { return $('<button/>').attr({ 'class': 'btn btn-primary', 'data-dyn-confirm': 'true', 'id': GSS.common.getUniqueId() }) }()),
            DefaultClose: (function () { return $('<button/>').attr({ 'class': 'btn btn-primary', 'data-dismiss': 'modal', 'data-dyn-confirm': 'true', 'id': GSS.common.getUniqueId() }) }()),
        },
        onCreate: function () {
            this.modal.Dialog.append(this.modalContent.Content);
            this.modalContent.HeaderTitle.empty().append(this.config.title);
            this.modalContent.Header.empty().append(this.modalContent.HeaderTitle);
            this.modalContent.Content.append(this.modalContent.Header);
            this.modalContent.Body.empty().append(this.config.message);
            this.modalContent.Content.append(this.modalContent.Body);

            if (this.config.isConfirmWindow) {
                $(this.action.OK).text(this.config.okLabel).one('click', function (event) {
                    let _callback = $('body').data('ok');
                    _callback.call(this);
                    Confirm.prototype.onClose();
                    event.stopImmediatePropagation();
                });

                this.modalContent.Footer.append(this.action.OK);

                $(this.action.Cancel).text(this.config.cancelLabel).one('click', function (event) {
                    let _callback = $('body').data('cancel');
                    _callback.call(this);
                    Confirm.prototype.onClose();
                    event.stopImmediatePropagation();
                });

                this.modalContent.Footer.append(this.action.Cancel);
                $(this.modalContent.Footer).css("text-align", "right");
            }
            else {
                $(this.action.DefaultClose).text(this.config.okLabel).one('click', function (event) {
                    let _callback = $('body').data('ok');
                    if ($.isFunction(_callback)) {
                        _callback.call(this);
                    }
                    Confirm.prototype.onClose();
                    event.stopImmediatePropagation();
                });
                this.modalContent.Footer.append(this.action.DefaultClose);
                $(this.modalContent.Footer).css("text-align", "center");
            }

            this.modalContent.Content.append(this.modalContent.Footer);
            this.dialogInstant = this.modal.Wrapper.append(this.modal.Dialog);

            $(this.elem).append(this.modal.OverLay);
            $(this.elem).append(this.dialogInstant);
            this.modal.Wrapper.show();
        },
        onClose: function () {
            $('[data-dyn-confirm]').each(function () {
                this.parentNode.removeChild(this);
            });
        },
    };

    // how to use:
    // set up data at view
    //<div id="confirm" data-confirm-options='{"message":"@this.Model.LocalizedContent[ResourceKeys.TeamManagement.DelMessage]", "title":"@this.Model.LocalizedContent[ResourceKeys.TeamManagement.RemoveHeader]", "cancelLabel":"@this.Model.LocalizedContent[ResourceKeys.Generic.Cancel]", "okLabel":"@this.Model.LocalizedContent[ResourceKeys.Generic.Remove]"}' > </div>

    $.fn.gssConfirmModal = function (options) {
        return new Confirm(this, options).init();
    };

    // for warning, only need displayed message, displayed text button and call back function for the button when is clicked (optional)
    $.fn.gssWarningModal = function (options) {
        options.isConfirmWindow = false;
        options.title = '';
        return new Confirm(this, options).init();
    };

    (<any>window).Confirm = Confirm;
})(jQuery, window, document, undefined);